/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import { StripeSetupService } from '../../service/StripeSetupService';
import StripeSetup from '../../models/StripeSetup';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import Stripe from '../../models/Stripe';
import CodeSetup from '../../models/CodeSetup';
import Chart from '../../models/Chart';
import SetupOptions from '../../models/SetupOptions';
import { Toast } from 'primereact/toast';
import User from '../../models/User';
import { UserService } from '../../service/UserService';
import { msalInstance } from '../../service/msal';
import { Card } from 'primereact/card';

interface StyleStripeDetailsProps {
    style?: string
    sequence: number
    stripeSequence: string
}

const StyleStripeDetails = (props: StyleStripeDetailsProps) => {
    let emptyStripeSetup: StripeSetup = {
        styleCd: '',
        sequence: 0,
        stripeSequence: '',
        detailOption: 0,
        stripeStyle: '',
        width: 0,
        stripeFabric: '',
        stripeYardage: 0,
        stripeChart: '',
        widthChart: '',
        colorChart: '',
        alternateColorChart: '',
        updateUser: '',
        updateTime: ''
    };

    const [stripeSetups, setStripeSetups] = useState<StripeSetup[]>([]);
    const [stripeSetup, setStripeSetup] = useState<StripeSetup>(emptyStripeSetup);
    const [stripeDetailOptions, setStripeDetailOptions] = useState<SetupOptions[]>([]);
    const [stripeFabrics, setStripeFabrics] = useState<CodeSetup[]>([]);
    const [stripeStyles, setStripeStyles] = useState<Stripe[]>([]);
    const [stripeCharts, setStripeCharts] = useState<Chart[]>([]);
    const [widths, setWidths] = useState<SetupOptions[]>([]);
    const [widthCharts, setWidthCharts] = useState<Chart[]>([]);
    const [colorCharts, setColorCharts] = useState<Chart[]>([]);
    const [selectedDetailOption, setSelectedDetailOption] = useState<number>(0);
    const [selectedStripeStyle, setSelectedStripeStyle] = useState<string>('');
    const [selectedStripeChart, setSelectedStripeChart] = useState<string>('');
    const [selectedStripeFabric, setSelectedStripeFabric] = useState<string>('');
    const [stripeYardage, setStripeYardage] = useState<number>(0);
    const [selectedWidth, setSelectedWidth] = useState<number>(0);
    const [selectedWidthChart, setSelectedWidthChart] = useState<string>('');
    const [selectedColorChart, setSelectedColorChart] = useState<string>('');
    const [selectedAlternateColorChart, setSelectedAlternateColorChart] = useState<string>('');
    const [user, setUser] = useState<User>();
    const toast = useRef<any>(null);
    const refStripeYardage = useRef<InputNumber>(null);
    const account = msalInstance.getActiveAccount();
    
    useEffect(() => {
        if (!props.style) { return; }

        if (stripeSetups.length === 0) {
            StripeSetupService.getStripeSetup(props.style).then(data => {
                setStripeSetups(data);
    
                if (data.length > 0) {
                    let _stripeSetup = data.filter(v => v.sequence === props.sequence && v.stripeSequence === props.stripeSequence)[0];
                    
                    if (_stripeSetup) {
                        setSelectedDetailOption(_stripeSetup.detailOption);
                        setSelectedStripeStyle(_stripeSetup.stripeStyle);
                        setSelectedStripeChart(_stripeSetup.stripeChart);
                        setSelectedStripeFabric(_stripeSetup.stripeFabric);
                        setStripeYardage(_stripeSetup.stripeYardage);
                        setSelectedWidth(_stripeSetup.width);
                        setSelectedWidthChart(_stripeSetup.widthChart);
                        setSelectedColorChart(_stripeSetup.colorChart);
                        setSelectedAlternateColorChart(_stripeSetup.alternateColorChart);
                        setStripeSetup(_stripeSetup);
                    }
                }
                
            });
        }

        StripeSetupService.getStripeDetailOptions().then(data => setStripeDetailOptions(data));
        StripeSetupService.getStripeFabrics().then(data => setStripeFabrics(data));
        StripeSetupService.getStripeStyles().then(data => setStripeStyles(data));
        StripeSetupService.getStripeCharts().then(data => setStripeCharts(data));
        StripeSetupService.getWidths().then(data => setWidths(data));
        StripeSetupService.getWidthCharts().then(data => setWidthCharts(data));
        StripeSetupService.getColorCharts().then(data => setColorCharts(data));
        
        if (account !== undefined && account !== null && account.name !== undefined) {
            let firstName = account?.name?.split(' ')[0];
            let lastName = account?.name?.split(' ')[1];
            UserService.getUser(firstName, lastName).then(data => {
                setUser(data);});
        }
    }, []);

    const saveStripeSetup = (stripeSetupData: StripeSetup) => {
        StripeSetupService.updateStripeSetup(stripeSetupData).then((data) => {
            if (data) {
                if (props.style) {
                    StripeSetupService.getStripeSetup(props.style).then(stripeData => {
                        setStripeSetups(stripeData);

                        let _stripeSetup = (stripeData.filter(v => v.sequence === props.sequence && v.stripeSequence === props.stripeSequence))[0];
                        setSelectedDetailOption(_stripeSetup.detailOption);
                        setSelectedStripeStyle(_stripeSetup.stripeStyle);
                        setSelectedStripeChart(_stripeSetup.stripeChart);
                        setSelectedStripeFabric(_stripeSetup.stripeFabric);
                        setStripeYardage(_stripeSetup.stripeYardage);
                        setSelectedWidth(_stripeSetup.width);
                        setSelectedWidthChart(_stripeSetup.widthChart);
                        setSelectedColorChart(_stripeSetup.colorChart);
                        setSelectedAlternateColorChart(_stripeSetup.alternateColorChart);
                        setStripeSetup(_stripeSetup);
                    });
                }

                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Stripe Setup Updated', life: 3000 });
                setStripeSetup(emptyStripeSetup);
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Stripe Setup Update Failed', life: 3000 });
            }
        });
    }
    
    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Toast ref={toast} />

                <Card>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Detail Option:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedDetailOption} options={stripeDetailOptions} optionLabel="setupOption" optionValue="setupId" className='w-full' onChange={(e) => setSelectedDetailOption(e.value)} showClear filter filterBy="value" placeholder="Detail Option" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Stripe Style:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedStripeStyle} options={stripeStyles} optionLabel="stripe_Desc" optionValue="stripe_Style" className='w-full' onChange={(e) => setSelectedStripeStyle(e.value)} showClear filter filterBy="value" placeholder="Stripe Style" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Stripe Chart:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedStripeChart} options={stripeCharts} optionLabel="chartDesc" optionValue="chartCd" className='w-full' onChange={(e) => setSelectedStripeChart(e.value)} showClear filter filterBy="value" placeholder="Stripe Chart" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Stripe Fabric:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedStripeFabric} options={stripeFabrics} optionLabel="description" optionValue="code" className='w-full' onChange={(e) => setSelectedStripeFabric(e.value)} showClear filter filterBy="value" placeholder="Stripe Fabric" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Stripe Yardage:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <InputNumber ref={refStripeYardage} value={stripeYardage} onValueChange={(e) => setStripeYardage(e.value as number)} className='w-full' inputClassName='w-full' mode="decimal" useGrouping={false} max={99.99} maxFractionDigits={2} placeholder="Stripe Yardage" />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Width:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedWidth} options={widths} optionLabel="setupOption" optionValue="setupId" className='w-full' onChange={(e) => setSelectedWidth(e.value)} showClear filter filterBy="value" placeholder="Width" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Width Chart:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedWidthChart} options={widthCharts} optionLabel="chartDesc" optionValue="chartCd" className='w-full' onChange={(e) => setSelectedWidthChart(e.value)} showClear filter filterBy="value" placeholder="Width Chart" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Color Chart:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedColorChart} options={colorCharts} optionLabel="chartDesc" optionValue="chartCd" className='w-full' onChange={(e) => setSelectedColorChart(e.value)} showClear filter filterBy="value" placeholder="Color Chart" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-2 md:col-2 md:mb-0 font-bold">
                            Alternate Color Chart:
                        </label>
                        <div className="col-12 md:col-3 -ml-7">
                            <Dropdown value={selectedAlternateColorChart} options={colorCharts} optionLabel="chartDesc" optionValue="chartCd" className='w-full' onChange={(e) => setSelectedAlternateColorChart(e.value)} showClear filter filterBy="value" placeholder="Alternate Color Chart" virtualScrollerOptions={{ itemSize: 50 }} />
                        </div>
                    </div>

                    <Button icon="pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={() => {
                        let _stripeSetup = { ...stripeSetup };
                        _stripeSetup.detailOption = selectedDetailOption === undefined ? 0 : selectedDetailOption;
                        _stripeSetup.stripeStyle = selectedStripeStyle === undefined ? '' : selectedStripeStyle;
                        _stripeSetup.stripeChart = selectedStripeChart === undefined ? '' : selectedStripeChart;
                        _stripeSetup.stripeFabric = selectedStripeFabric === undefined ? '' : selectedStripeFabric;
                        _stripeSetup.stripeYardage = stripeYardage ?? 0;
                        _stripeSetup.width = selectedWidth === undefined ? 0 : selectedWidth;
                        _stripeSetup.widthChart = selectedWidthChart === undefined ? '' : selectedWidthChart;
                        _stripeSetup.colorChart = selectedColorChart === undefined ? '' : selectedColorChart;
                        _stripeSetup.alternateColorChart = selectedAlternateColorChart === undefined ? '' : selectedAlternateColorChart;
                        _stripeSetup.styleCd = props.style ?? '';
                        _stripeSetup.sequence = props.sequence ?? 0;
                        _stripeSetup.stripeSequence = props.stripeSequence ?? '';
                        _stripeSetup.updateTime = new Date().toISOString();
                        _stripeSetup.updateUser = account?.username.split('@')[0] ?? '';
                        saveStripeSetup(_stripeSetup);
                    }}/>
                    <Button icon="pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={() => {
                        let _stripeSetup = { ...stripeSetup };
                        setSelectedDetailOption(_stripeSetup.detailOption);
                        setSelectedStripeStyle(_stripeSetup.stripeStyle);
                        setSelectedStripeChart(_stripeSetup.stripeChart);
                        setSelectedStripeFabric(_stripeSetup.stripeFabric);
                        setStripeYardage(_stripeSetup.stripeYardage);
                        setSelectedWidth(_stripeSetup.width);
                        setSelectedWidthChart(_stripeSetup.widthChart);
                        setSelectedColorChart(_stripeSetup.colorChart);
                        setSelectedAlternateColorChart(_stripeSetup.alternateColorChart);
                    }} />
                </Card>
            </div>
        </div>
    );
};

export default StyleStripeDetails;